import { AssetsHome as View } from "@/components.assets/assets-home";
export const Assets = {
	path: "/assets",
	name: "assets",
	component: View,
	meta: {
		title: "Assets",
		// icon: "library"
	}
};